// extracted by mini-css-extract-plugin
export default {"avatarCell":"AvatarCell_avatarCell__agXPP"};